<template>
  <div>
    <b-ace-editor :readonly="disabled" :snippets="true" :value="value" :height="height" @input="$emit('input', $event)" lang="json"> </b-ace-editor>
  </div>
</template>
<script>
import Vue from 'vue';
import Editor from 'bin-ace-editor';
require('brace/ext/language_tools');
require('brace/mode/json');
require('brace/snippets/json');
require('brace/theme/chrome');
Vue.component(Editor.name, Editor);
export default {
  props: {
    value: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '160'
    }
  }
};
</script>
<style lang="less"></style>
